/* ── Identificação da empresa ─────────────────────────────────────────────
   Rodapé sem identificação é o que mais derruba confiança em serviço que recebe
   pagamento — e a mesma ausência conta contra a página na busca.

   A identificação usa o NOME FANTASIA, por decisão do dono do negócio; o CNPJ
   ao lado é o que identifica a empresa juridicamente.

   `MARCA_REGISTRADA` só vira `true` quando o registro for CONCEDIDO pelo INPI.
   Usar ® antes disso é irregular; até lá, o símbolo correto é ™, que indica uso
   da marca sem exigir registro. */
export const NOME_FANTASIA = 'BAIXA XML';
export const CNPJ = '43.011.795/0001-46';
export const MARCA_REGISTRADA = false;
export const ANO_INICIO = 2026;

